import CancelOrderConfirm from './CancelOrderConfirm/CancelOrderConfirm.css';
export default {
    CancelOrderConfirm
};
